import React from 'react'
import {
  ADMIN_ROUTE,
  PROFILE_ROUTE,
  PROFILECOMPANY_ROUTE,
  PROJECTS_ROUTE,
  PROJECTS_NEW_ROUTE,
  PROJECTNEW_ROUTE,
  COMPANYS_ROUTE,
  SPECIALIST_ROUTE,
  PLATFORMS_ROUTE,
  CHAT_MANAGER,
  CHAT_WORKER,
  CHAT_SUPPORT,
  AIR_ROUTE,
  CLIENT_ROUTE,
  PAY_RATE_ROUTE,
  SETTINGS_ROUTE,
  PARTNER_ROUTE,
  DOCUMENT_ROUTE,
  DOCUMENT_COMPLECT_ROUTE,
  ESTIMATE_ROUTE,
  ESTIMATE_LIST_ROUTE,
} from './utils/consts'

const Admin = React.lazy(() => import('./pages/Admin'))
const Profile = React.lazy(() => import('./pages/Profile'))
const ProfileCompany = React.lazy(() => import('./pages/ProfileCompany'))

// Projects: Старая стабильная версия (используется в продакшене)
const Projects = React.lazy(() => import('./pages/Projects'))

// ProjectsNew: Рефакторенная версия (в разработке, доступна по /project_v2)
const ProjectsNew = React.lazy(() => import('./pages/projects/ProjectsNew'))

const ProjectNew = React.lazy(() => import('./pages/ProjectNew'))

// const Air = React.lazy(() => import('./pages/Air'))
const Air = React.lazy(() => import('./views/projects/onair/OnAir'))

const Specialist = React.lazy(() => import('./pages/Specialist'))
const Companys = React.lazy(() => import('./pages/Companys'))
const Platforms = React.lazy(() => import('./pages/Platforms'))

const PayRate = React.lazy(() => import('./views/estimates/PayRate'))
const EstimateList = React.lazy(() => import('./views/estimates/EstimateList'))
const Estimate = React.lazy(() => import('./views/estimates/Estimate'))
const Companies = React.lazy(() => import('./views/companies/Companies'))
const Document = React.lazy(() => import('./views/documents/Document'))
const DocumentsGenerator = React.lazy(() => import('./views/documents/DocumentsGenerator'))

const ChatWorker = React.lazy(() => import('./pages/ChatWorker'))
const ChatManager = React.lazy(() => import('./pages/ChatManager'))
const ChatSupport = React.lazy(() => import('./pages/ChatSupport'))
const Client = React.lazy(() => import('./pages/Client'))

const Settings = React.lazy(() => import('./pages/Settings'))

export const authRoutes = [
  { path: '/', name: 'Пункт управления', Component: Admin },
  { path: ADMIN_ROUTE, name: 'Панель управления', Component: Admin },

  { path: PROJECTS_ROUTE, name: 'Проекты', Component: Projects },
  { path: PROJECTS_NEW_ROUTE, name: 'Проекты v2 (новая версия)', Component: ProjectsNew },
  { path: PROJECTNEW_ROUTE, name: 'Новая заявка', Component: ProjectNew },
  { path: AIR_ROUTE, name: 'В эфире', Component: Air },
  { path: COMPANYS_ROUTE, name: 'Компании', Component: Companys },
  { path: PLATFORMS_ROUTE, name: 'Локации', Component: Platforms },

  { path: CHAT_MANAGER, name: 'Клиент', Component: ChatManager },
  { path: CLIENT_ROUTE, name: 'Профиль клиента', Component: Client },

  { path: CHAT_WORKER, name: 'Сотрудники', Component: ChatWorker },
  { path: SPECIALIST_ROUTE, name: 'Профиль сотрудника', Component: Specialist },

  { path: CHAT_SUPPORT, name: 'Техническая поддержка', Component: ChatSupport },

  { path: PROFILE_ROUTE, name: 'Профиль', Component: Profile },
  { path: PROFILECOMPANY_ROUTE, name: 'Профиль компании', Component: ProfileCompany },
  { path: SETTINGS_ROUTE, name: 'Настройки', Component: Settings },
  { path: PAY_RATE_ROUTE, name: 'Ставки', Component: PayRate },

  { path: PARTNER_ROUTE, name: 'Компаний', Component: Companies },
  { path: DOCUMENT_ROUTE, name: 'Докумненты', Component: DocumentsGenerator },
  { path: DOCUMENT_COMPLECT_ROUTE, name: 'Комплекты документов', Component: Document },
  { path: ESTIMATE_LIST_ROUTE, name: 'Сметы', Component: EstimateList },
  { path: ESTIMATE_ROUTE, name: 'Сметы', Component: Estimate },
]
